import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'ark-confirm-timeout',
  templateUrl: './confirm-timeout.component.html',
  styleUrls: ['./confirm-timeout.component.scss']
})
export class ConfirmTimeoutComponent implements OnInit {

  subject: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmTimeoutComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.subject = this.data.subject;
  }

  close(flag = false) {
    this.dialogRef.close(flag);
  }
}